import axiosInstance from "app/axios";
import { AxiosResponse } from "axios";
import { LotOfferStatus } from "interfaces/LotOfferStatus";
import { UserRoles } from "interfaces/UserRoles";

export interface fetchBulkStatusLotOffersInterface {
  ids: string[];
  status: LotOfferStatus;
  endpoint?: UserRoles;
  published_at?: string;
}

export interface BulkUpdateLotOffersResponseInterface {
  errors?: {
    ids: string[];
  }
}

export function fetchBulkStatusLotOffers({ ids, status, published_at, endpoint = UserRoles.Admin }: fetchBulkStatusLotOffersInterface): Promise<AxiosResponse<BulkUpdateLotOffersResponseInterface, any>> {
  return axiosInstance.patch(`${endpoint}/lot_offers/bulk_update`, { ids, status, published_at });
}
